var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.909 0 0 17.909 0 40s17.909 40 40 40 40-17.909 40-40C79.992 17.912 62.088.008 40 0zm0 72C22.327 72 8 57.673 8 40 8 22.327 22.327 8 40 8c17.673 0 32 14.327 32 32-.023 17.664-14.336 31.977-32 32zm15.52-46.84L32 48.68l-7.52-7.52c-1.007-1.007-2.476-1.401-3.852-1.032s-2.451 1.444-2.82 2.82c-.369 1.376.025 2.845 1.032 3.852L29.2 57.16c.747.75 1.762 1.17 2.82 1.17 1.058 0 2.073-.42 2.82-1.17L61.2 30.8c.75-.747 1.17-1.762 1.17-2.82 0-1.058-.42-2.073-1.17-2.82-1.572-1.56-4.108-1.56-5.68 0z",
    transform: "translate(-587 -318) translate(587 318)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSuccess);
export default __webpack_public_path__ + "static/media/icons-success.0b650024ef0984c005cd64c7d255be73.svg";
export { ForwardRef as ReactComponent };